import React from 'react';
import styled from 'styled-components';
import { USTerms } from '../../../@types/USTerms';
import appConfig from '../../../appConfig';
import CheckBox from '../../../components/CheckBox';

const stateConfig = {
	OH: {
		tcLink: 'https://www.playup.com/ohio-terms-and-conditions/',
		privacyLink: 'https://www.playup.com/ohio-privacy-policy/',
		checkLabel:
			'I am not a casino employee prohibited from wagering in any casino or simulcasting facility in the State of Ohio. I am not a prohibited sports pool participant or otherwise prohibited from engaging in sports wagering.',
	},
	IA: {
		tcLink: 'https://www.playup.com/iowa-terms-and-conditions/',
		privacyLink: 'https://www.playup.com/iowa-privacy-policy/',
		checkLabel:
			'I am not a casino employee prohibited from wagering in any casino or simulcasting facility in the State of Iowa. I am not a prohibited sports pool participant or otherwise prohibited from engaging in sports wagering.',
	},
}[appConfig.regions.usState];

const SignUpTandC = (props: Props) => {
	return (
		<ConfirmationSection>
			<CheckBox
				checked={props.ts.termsAndConditions}
				onClick={() => props.setter('termsAndConditions')}
				label={
					<span>
						I accept the{' '}
						<a href={stateConfig?.tcLink} target="_blank" rel="noreferrer" className="_text-secondary">
							Terms and Conditions
						</a>{' '}
						and the{' '}
						<a href={stateConfig?.privacyLink} target="_blank" rel="noreferrer" className="_text-secondary">
							Privacy Policy
						</a>
						. I also accept that my age and identity will be verified securely.
					</span>
				}
			/>
			<CheckBox
				checked={props.ts.notACasinoEmployee}
				onClick={() => props.setter('notACasinoEmployee')}
				label={stateConfig?.checkLabel}
			/>
			<CheckBox
				checked={props.ts.isTwentyOne}
				onClick={() => props.setter('isTwentyOne')}
				label="I confirm that I am 21+ years old and acknowledge that I may not allow any other person to use or access my account."
			/>
		</ConfirmationSection>
	);
};

export default SignUpTandC;

interface Props {
	ts: USTerms;
	setter: (action) => void;
	editable?: boolean;
}

const ConfirmationSection = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: space-around;
	padding: 12px;
	> * {
		padding-bottom: 15px;
	}
`;
